export default class MinMaxParam {
    min: number = 0;
    max: number = 0;
}